import Handlebars from "handlebars";

Handlebars.registerHelper("index", function (index, options) {
  return parseInt(index, 10) + 1;
});
